import React from 'react';
import ProductCard from './ProductCard';
import ArtworkCard from './ArtworkCard';
import { Product, Artwork } from '../../data/products';
import './ProductGrid.css';

interface ProductGridProps {
  products?: Product[];
  artworks?: Artwork[];
  columns?: 2 | 3 | 4;
  emptyMessage?: string;
}

const ProductGrid: React.FC<ProductGridProps> = ({
  products = [],
  artworks = [],
  columns = 3,
  emptyMessage = 'No items found.',
}) => {
  const hasItems = products.length > 0 || artworks.length > 0;

  if (!hasItems) {
    return (
      <div className="product-grid-empty" role="status">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={`product-grid product-grid--${columns}-col`}>
      {products.map((p) => (
        <ProductCard key={p.id} product={p} />
      ))}
      {artworks.map((a) => (
        <ArtworkCard key={a.id} artwork={a} />
      ))}
    </div>
  );
};

export default ProductGrid;
